import { onlineFactorService } from '@/common/shop.service'

const initialStates = {
    detailItem: {
        status: 'loading',
        data: [],
    },
    item: {

    },
    detailCustomer: {
        status: 'loading',
        data: [],
    },
    createItem: {
        status: 'loading',
        data: [],
    },
    detailFactor: {
        status: 'loading',
        data: []
    }
}

const mutations = {
    loading(state) {
        state.status = 'loading'
        state.data = []

    },
    success(state, data) {
        state.status = 'success'
        state.data = data
    },
    showData(state, data) {
        state.detailItem.status = 'success'
        state.detailItem.data = data
    },
    archiveItem(state, data) {
        state.item.status = 'success'
        state.item.data = data
    },
    showCustomerData(state, data) {
        state.detailCustomer.status = 'success'
        state.detailCustomer.data = data
    },
    createItemData(state, data) {
        state.createItem.status = 'success'
        state.createItem.data = data
    },
    showFactorData(state, data) {
        state.detailFactor.status = 'success'
        state.detailFactor.data = data
    }
}

const getters = {
    detailItem: ({ detailItem }) => detailItem.data,
    detailCustomer: ({ detailCustomer }) => detailCustomer.data,
    detailFactor:({ detailFactor }) => detailFactor.data,
    detailCustomerStatus: ({ detailCustomer }) => detailCustomer.status,
    item: ({ item }) => item.data,
    createItem: ({ item }) => item.data
}

const actions = {
    showItem({ commit }, hashid) {
        commit('loading')
        return onlineFactorService.showItem(hashid).then(response => {
            commit('showData', response.data.data)
        })
    },
    createItem({ commit }, params) {
        commit('loading')
        return onlineFactorService.createItem(params).then(response => {
            commit('createItemData', response.data.data)
        })
    },
    showCustomer({ commit }, hashid) {
        commit('loading')
        return onlineFactorService.showCustomer(hashid).then(response => {
            commit('showCustomerData', response.data.data)
        })
    },
    archiveItem({ commit }, hashid) {
        commit('loading')
        return onlineFactorService.archiveItem(hashid).then(response => {
            commit('archiveItem', response.data.data)
        })
    },
    showFactor({ commit }, hashid) {
        commit('loading')
        return onlineFactorService.showFactor(hashid).then(response => {
            commit('showFactorData', response.data.data)
        })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}
